import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert,
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { checkBadanteAPI, checkBadanteNomeCognomeAPI, checkBadanteTelefonoAPI, generateContrattoBadante, getBadanteAPI, modifyBadanteAPI } from "../../data/api";
import BadanteBozzaForm from "./BadanteBozzaForm";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { formConfig } from "./config";
import { Modal } from "react-bootstrap";
import ModifyBadanteBozzaForm from "./ModifyBadanteBozzaForm";
import { format } from "date-fns";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39"
};

const ModifyBadanteForm = (props) => {
  const [loading, setLoading] = useState(true);
  const [emptyState, setEmptyState] = useState(false);
  const [error, setError] = useState(false);
  const [loadingModify, setLoadingModify] = useState(false);
  const [errorModify, setErrorModify] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idBadante = queryParams.get('id');

  // modify BadanteBozza form data
  const [modifyBadanteFormValuesSaved, setModifyBadanteFormValuesSaved] = useState(defaultForm); // the data on the DB
  const [modifyBadanteFormValuesLocal, setModifyBadanteFormValuesLocal] = useState(() => { // the local draft
    const storage = localStorage.getItem('modifyBadanteFormValues-'+idBadante);
    return storage ? JSON.parse(storage) : defaultForm;
  });

  const changeInputModifyBadanteForm = (e) => {
    const { name, value } = e.target;
    const newValue = { ...modifyBadanteFormValuesLocal };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setModifyBadanteFormValuesLocal(newValue);
    localStorage.setItem('modifyBadanteFormValues-'+idBadante, JSON.stringify(newValue));
  };
  
  const getBadante = async (id) => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const badanteResponse = await getBadanteAPI(id);
      setModifyBadanteFormValuesSaved(badanteResponse)
      if(localStorage.getItem('modifyBadanteFormValues-'+idBadante) === null){
        setModifyBadanteFormValuesLocal(badanteResponse)
      }
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        setEmptyState(true);
      } else {
        console.log('Loading badante '+id+' failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  const resetModifyBadanteForm = () => {
    setModifyBadanteFormValuesLocal(defaultForm);
    localStorage.removeItem('modifyBadanteFormValues-'+idBadante);
  }

  const modifyBadanteBozza = async (generaContratto) => {
    try{
      setLoadingModify(true);
      setErrorModify(false);
      let attivo = modifyBadanteFormValuesLocal['Attivo'];
      if(attivo !== 'Da non considerare'){
        // check if documentazione is completa
        if(showAlertPermessoSoggiorno || showAlertDocumenti){
          attivo = 'Incompleto'
          // check disponibilità futura
        } else if(modifyBadanteFormValuesLocal['Data_Disponibilita'] === undefined 
          || modifyBadanteFormValuesLocal['Data_Disponibilita'] === null 
          || modifyBadanteFormValuesLocal['Data_Disponibilita'] > format(new Date(), 'yyyy-MM-dd')){
          attivo = 'Impegnato altrove'
        } else {
          attivo = 'Disponibile'
        }
      }
      console.log(modifyBadanteFormValuesLocal['Data_Disponibilita'])
      if(generaContratto){
        await modifyBadanteAPI({...modifyBadanteFormValuesLocal, Attivo: attivo});
        const responseScheda = await generateContrattoBadante(idBadante);
        await modifyBadanteAPI({...modifyBadanteFormValuesLocal, Attivo: attivo, Contratto: responseScheda.contratto_path, Contratto_Esteso: responseScheda.contratto_esteso_path});
      } else {
        await modifyBadanteAPI({...modifyBadanteFormValuesLocal, Attivo: attivo});
      }
      setLoadingModify(false);
      navigate('/os/detail?id='+idBadante)
      resetModifyBadanteForm();
    } catch (e) {
      console.log('Modify Badante Bozza failed ', e);
      setErrorModify(true);
      setLoadingModify(false);
    }
  };
  
  useEffect(() => {
    getBadante(idBadante);
  }, []);

  // check if duplicate
  const [showAlertDuplicate, setShowAlertDuplicate] = useState(false);
  const checkBadanteDuplicato = async () => {
    const nome = modifyBadanteFormValuesLocal['Nome'];
    const cognome = modifyBadanteFormValuesLocal['Cognome'];
    const telefono = modifyBadanteFormValuesLocal['Telefono'];
    if(nome !== '' && cognome !== '' && telefono !== '' && nome !== null && cognome !== null && telefono !== null){
      try{
        const check = await checkBadanteAPI(nome, cognome, telefono, idBadante);
        if(check.exists){
          setShowAlertDuplicate(true);
        } else {
          setShowAlertDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante failed ', e);
        setShowAlertDuplicate(false);
      }
    } else {
      setShowAlertDuplicate(false);
    }
  }

  // check if nome cognome is duplicate
  const [showAlertNomeCognomeDuplicate, setShowAlertNomeCognomeDuplicate] = useState(false);
  const checkBadanteNomeCognomeDuplicato = async () => {
    const nome = modifyBadanteFormValuesLocal['Nome'];
    const cognome = modifyBadanteFormValuesLocal['Cognome'];
    if(nome !== '' && cognome !== '' && nome !== null && cognome !== null) {
      try{
        const check = await checkBadanteNomeCognomeAPI(nome, cognome, idBadante);
        if(check.exists){
          setShowAlertNomeCognomeDuplicate(true);
        } else {
          setShowAlertNomeCognomeDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante nome cognome failed ', e);
        setShowAlertNomeCognomeDuplicate(false);
      }
    } else {
      setShowAlertNomeCognomeDuplicate(false);
    }
  }

  const [showAlertTelefonoDuplicate, setShowAlertTelefonoDuplicate] = useState(false);
  const checkBadanteTelefonoDuplicato = async () => {
    const telefono = modifyBadanteFormValuesLocal['Telefono'];
    if(telefono !== '' && telefono !== null) {
      try{
        const check = await checkBadanteTelefonoAPI(telefono, idBadante);
        if(check.exists){
          setShowAlertTelefonoDuplicate(true);
        } else {
          setShowAlertTelefonoDuplicate(false);
        }
      } catch (e) {
        console.log('Check badante telefono failed ', e);
        setShowAlertTelefonoDuplicate(false);
      }
    } else {
      setShowAlertTelefonoDuplicate(false);
    }
  }

  const onBlurField = (e) => {
    if(e.target.name === 'Nome' || e.target.name === 'Cognome' || e.target.name === 'Telefono'){
      checkBadanteDuplicato()
    }
    if(e.target.name === 'Nome' || e.target.name === 'Cognome'){
      checkBadanteNomeCognomeDuplicato()
    }
    if(e.target.name === 'Telefono'){
      checkBadanteTelefonoDuplicato()
    }
  }

  useEffect(() => {
    checkBadanteDuplicato()
    checkBadanteNomeCognomeDuplicato()
    checkBadanteTelefonoDuplicato()
  }, []);


  const [isSchedaButtonDisabled, setIsSchedaButtonDisabled] = useState(true);
  useEffect(() => {
    const isAnyFieldEmpty = formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequiredScheda ?? false))
      .map(field => field.name)
      .some(field => !modifyBadanteFormValuesLocal[field] 
        || modifyBadanteFormValuesLocal[field] === '' 
        || JSON.stringify(modifyBadanteFormValuesLocal[field]) === '{}');
    setIsSchedaButtonDisabled(isAnyFieldEmpty);
  }, [modifyBadanteFormValuesLocal]);

  const [missingAttributesScheda, setMissingAttributesScheda] = useState([]);
  useEffect(() => {
    setMissingAttributesScheda(formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequiredScheda ?? false))
      .filter(field => !modifyBadanteFormValuesLocal[field.name] 
        || modifyBadanteFormValuesLocal[field.name] === '' 
        || JSON.stringify(modifyBadanteFormValuesLocal[field.name]) === '{}')
      .map(f => f.label));
  }, [modifyBadanteFormValuesLocal]);

  // confirm generate button modal state
  const [isModalVisible, setIsModalVisible] = useState(false);

  // alert permesso soggiorno
  const [showAlertPermessoSoggiorno, setShowAlertPermessoSoggiorno] = useState(false);
  useEffect(() => {
    setShowAlertPermessoSoggiorno(
      (modifyBadanteFormValuesLocal['Italiano'] === 'No' &&
      modifyBadanteFormValuesLocal['Comunita_Europea'] === 'No') &&
      (modifyBadanteFormValuesLocal['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Permesso di soggiorno' || t === 'Visto') === undefined
    )
  }, [modifyBadanteFormValuesLocal]);

  // alert documento riconoscimento
  const [showAlertDocumenti, setShowAlertDocumenti] = useState(false);
  useEffect(() => {
    setShowAlertDocumenti(
      (modifyBadanteFormValuesLocal['Documenti'] ?? []).map(d => d.Tipo).find(t => t === 'Carta di identità' || t === 'Passaporto' || t === 'Patente') === undefined
    )
  }, [modifyBadanteFormValuesLocal]);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to={'/os/detail?id='+idBadante} className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
        }}>
            <h2>Modifica operatore sanitario</h2>
            <View>
             {loadingModify ? <Loader/> : <>
              <Button
                onClick={() => modifyBadanteBozza(false)}
                variation="primary"
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
              >
                { "Salva modifiche"}
              </Button>
              <Button
                onClick={() => setIsModalVisible(true)}
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
                marginLeft="15px"
              >
                { "Salva modifiche e genera scheda"}
              </Button>
              { errorModify ? <View><span style={{color: "red", marginLeft: "auto"}}>Errore nella modifica!</span></View> : ""}
              </>}
            </View>
        </div>
      {
        loading ? <Loader/> : 
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">OS non trovato</Alert> :
        <>
          <Flex as="form" direction="column">
              {showAlertDuplicate && <Alert variation="error">Attenzione: esiste già un OS con questa anagrafica di base. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
              {JSON.stringify(modifyBadanteFormValuesLocal) !== JSON.stringify(modifyBadanteFormValuesSaved) && <Alert variation="warning">Attenzione: ci sono dati modificati non salvati.</Alert>}
              {showAlertNomeCognomeDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un OS con lo stesso nome e cognome. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {showAlertTelefonoDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un OS con lo stesso numero di telefono. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
              {(modifyBadanteFormValuesLocal.CF === null || modifyBadanteFormValuesLocal.CF === undefined || modifyBadanteFormValuesLocal.CF === '') && 
                <Alert variation="warning">Attenzione: codice fiscale non specificato.</Alert>}
              {showAlertPermessoSoggiorno && <Alert variation="warning">Attenzione: l'OS non fa parte della Comunità Europea o non possiede cittadinanza italiana, è necessario caricare il permesso di soggiorno o il visto per completarne la documentazione.</Alert>}
              {showAlertDocumenti && <Alert variation="warning">Attenzione: documento di riconoscimento mancante (carta d'identità, patente o passaporto).</Alert>}
              {missingAttributesScheda.length > 0 && 
              <Alert variation="info">Attenzione: non sono stati compilati tutti i campi obbligatori per il contratto ({missingAttributesScheda.join(', ')}).</Alert>}
              <BadanteBozzaForm
                  formConfig={formConfig}
                  value={modifyBadanteFormValuesLocal}
                  savedValue={modifyBadanteFormValuesSaved}
                  onChange={changeInputModifyBadanteForm}
                  onBlur={onBlurField}
                  typeForm="Scheda">
              </BadanteBozzaForm>
            <View textAlign={"right"}>
             {loadingModify ? <Loader/> : <>
              <Button
                onClick={() => modifyBadanteBozza(false)}
                variation="primary"
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
              >
                { "Salva modifiche"}
              </Button>
              <Button
                onClick={() => setIsModalVisible(true)}
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate}
                width={"fit-content"}
                alignSelf={"right"}
                marginLeft="15px"
              >
                { "Salva modifiche e genera scheda"}
              </Button></>}
            </View>
          { errorModify ? <span style={{color: "red", marginLeft: "auto"}}>Errore nella modifica!</span> : ""}
          </Flex>
        </>
      }
      </View>
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Conferma generazione scheda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text>Sei sicuro di voler generare la scheda per l'operatore sanitario?</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variation="primary" onClick={async () => {setIsModalVisible(false); await modifyBadanteBozza(true);}}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </View>
  );
};

export default ModifyBadanteForm;
